import { createI18n } from 'vue-i18n'
import deLocale from '@/locales/de-de.json'

const i18n = createI18n({
  legacy: false, // you must specify 'legacy: false' option
  locale: 'de-de',
  fallback: 'de-de',
  messages: {
    'de-de': deLocale,
  },
})

export const supportedLocales = ['en-en', 'de-de']

export const loadLocale = async (locale) => {
  // Use explicit imports to avoid dynamic import issues
  let messages;
  if (locale === 'de-de') {
    messages = await import('@/locales/de-de.json');
  } else if (locale === 'en-en') {
    messages = await import('@/locales/en-en.json');
  } else {
    messages = await import('@/locales/de-de.json'); // fallback
  }
  i18n.global.setLocaleMessage(locale, messages.default || messages);
  i18n.global.locale.value = locale;
}

export default i18n
